<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :cancelar-cadastro="cancelar"
    >
      <template slot="conteudo">
        <b-row>
          <b-col cols="3">
            <b-form-group label="Tipo de Configuração">
              <b-select
                v-model="form.tipoConfiguracao"
                :options="[{ value: 'google', text: 'Google' }, { value: 'smtp', text: 'SMTP' }]"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="form.tipoConfiguracao == 'smtp'">
          <b-form-group
            label="Servidor de saída de e-mails"
            class="col-md-6"
          >
            <validation-provider
              #default="{ errors }"
              rules="required|url"
              name="Servidor"
            >
              <b-form-input
                v-model="form.servidor"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-col cols="3">
            <b-form-group label="Porta">
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Porta"
              >
                <b-input
                  v-model="form.porta"
                  :state="errors.length > 0 ? false : null"
                  class="form-control"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group label="Criptografia">
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Criptografia"
              >
                <b-select
                  v-model="form.cripto"
                  :options="criptos"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group label="E-mail do Remetente">
              <validation-provider
                #default="{ errors }"
                rules="email"
                name="E-mail"
              >
                <b-form-input v-model="form.email" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            v-if="form.tipoConfiguracao == 'smtp'"
            cols="6"
          >
            <b-form-group label="Senha">
              <senha-input
                v-model="form.senha"
                auto-complete-senha="new-password"
              />
            </b-form-group>
          </b-col>
          <b-col v-if="form.tipoConfiguracao == 'google'">
            <b-form-group style="margin-top: 1.9rem;">
              <b-btn
                v-if="!form.logadoGoogle"
                variant="none"
                :class="['login-with-google-btn', { 'logado': form.logadoGoogle }]"
                @click="iniciarLoginAutenticacao"
              >
                Entrar com o Google
              </b-btn>
              <b-btn
                v-if="form.logadoGoogle"
                variant="none"
                :class="['login-with-google-btn', { 'logado': form.logadoGoogle }]"
                @click="deslogarGoogle"
              >
                Deslogar do Google
              </b-btn>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="form.tipoConfiguracao == 'smtp'">
          <b-col cols="6">
            <b-form-group label="Descrição remetente">
              <b-form-input v-model="form.remetente" />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-form-group label="Assinatura do E-mail">
              <upload-e-visualizacao
                ref="upload"
                :value="form.smtpAssinatura"
                :titulo="'assinatura'"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </template>
    </cadastro-base>
  </div>
</template>

<style lang="scss">
.login-with-google-btn {
  transition: background-color .3s, box-shadow .3s;

  padding: 12px 16px 12px 42px;
  border: 1px solid rgb(255, 0, 0);
  border-radius: 3px;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, .04), 0 1px 1px rgba(0, 0, 0, .25);

  color: #757575;
  font-size: 14px;
  font-weight: 500;

  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMyAxMiAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4=);
  background-color: white;
  background-repeat: no-repeat;
  background-position: 12px 11px;

  &:hover {
    box-shadow: 0 -1px 0 rgba(0, 0, 0, .04), 0 2px 4px rgba(0, 0, 0, .25);
  }

  &:active {
    background-color: #eeeeee;
  }

  &:focus {
    outline: none;
    box-shadow:
      0 -1px 0 rgba(0, 0, 0, .04),
      0 2px 4px rgba(0, 0, 0, .25),
      0 0 0 3px #c8dafc;
  }
}

.logado {
  border: 1px solid #28c76f;
}
</style>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required, email, url,
} from '@validations'
import { initClientGoogle } from '@/shared/mixins/login-google/login-google'
import api from '@/app-modulo/plataforma/email-config/shared/services/api'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'

export default {
  name: 'EmailConfiguracao',
  components: {
    CadastroBase,
    ValidationProvider,
    SenhaInput: () => import('@/shared/components/senha-input/SenhaInput.vue'),
    UploadEVisualizacao: () => import('@/shared/components/upload-e-visualizacao/UploadEVisualizacao.vue'),
  },
  data() {
    return {
      required,
      email,
      url,
      form: {
        servidor: null,
        porta: null,
        cripto: 'nenhum',
        smtpAssinatura: null,
        refreshToken: null,
        tipoConfiguracao: 'google',
      },
      criptos: [{
        text: 'Nenhum',
        value: 'nenhum',
      },
      {
        text: 'SSL',
        value: 'ssl',
      },
      {
        text: 'TSL',
        value: 'tsl',
      }],
    }
  },
  created() {
    this.carregar()
  },
  methods: {
    carregar() {
      api.getEmailConfiguracao()
        .then(payload => {
          this.form = payload.data
          if (!this.form) {
            this.form = {}
          }
        })
    },
    salvar() {
      return new Promise((resolve, reject) => {
        const form = { ...this.form }
        form.smtpAssinatura = null

        const formData = this.$refs.upload.getFormDataBody(form)
        api.updateEmailConfiguracao(formData)
          .then(() => {
            resolve('Configuração de e-mail cadastrada com sucesso')
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    cancelar() {
    },
    iniciarLoginAutenticacao() {
      api.getClientGoogle()
        .then(payload => {
          initClientGoogle(this.loginGoogle, payload.data)
        })
    },
    loginGoogle(tokenResponse) {
      api.autenticarGoogle(tokenResponse.code, this.form.email)
        .then(payload => {
          this.form = payload.data
          this.form.tipoConfiguracao = 'google'
          this.form.logadoGoogle = true
          this.$sucesso('Conectado com sucesso')
        })
        .catch(err => {
          this.$erro(err.response.data.message || err.message)
          throw err
        })
    },
    deslogarGoogle() {
      api.deslogarGoogle()
        .then(payload => {
          if (payload.data) {
            this.form.email = null
            this.form.refreshToken = null
            this.form.logadoGoogle = false
            this.$sucesso('Desconectado da conta')
          }
        })
        .catch(err => {
          this.$erro(err.response.data.message || err.message)
          throw err
        })
    },
  },
}
</script>
